import {
  ZoomControls,
  ZoomButton,
  ZoomButtonIcon,
} from 'atomicComponents/Zoomable/ZoomControls';
import { BubbleChartZoomControlsProps } from '@ardoq/bubble-chart';
import { ComponentWithDropdown, ComponentProps } from '@ardoq/dropdown-menu';
import styled from 'styled-components';
import { spacing } from '@ardoq/design-tokens';
import { IconName } from '@ardoq/icons';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs/operators';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { I18nLocale, type WithI18nLocale } from '@ardoq/i18n';

const ZoomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: end;
  padding-right: ${spacing.s8};
`;

type SelectQuadrantButtonProps = {
  iconName: IconName;
} & ComponentProps;

const SelectQuadrantButton = ({
  iconName,
  onMenuOpen,
  ref,
}: SelectQuadrantButtonProps) => (
  <ZoomButton ref={ref} onClick={onMenuOpen} style={{ position: 'relative' }}>
    <ZoomButtonIcon iconName={iconName} />
  </ZoomButton>
);

type BubbleChartZoomControlsViewProps = BubbleChartZoomControlsProps &
  WithI18nLocale;

const BubbleChartZoomControlsView = ({
  i18nLocale,
  ...props
}: BubbleChartZoomControlsViewProps) => (
  <ZoomContainer>
    <ZoomControls {...props} i18nLocale={i18nLocale}>
      {props.selectQuadrantButtonProps && (
        <ComponentWithDropdown
          options={props.selectQuadrantButtonProps.options}
          Component={SelectQuadrantButton}
          componentProps={{
            iconName: props.selectQuadrantButtonProps.iconName,
          }}
        ></ComponentWithDropdown>
      )}
    </ZoomControls>
  </ZoomContainer>
);

const toI18nLocaleProps = (i18nLocale: I18nLocale): WithI18nLocale => ({
  i18nLocale,
});

export const BubbleChartZoomControls = connect(
  BubbleChartZoomControlsView,
  i18nLocale$.pipe(map(toI18nLocaleProps))
);
